var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3 ml-3"},[_c('CtaButton',{attrs:{"text":"Example"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }